var React = require('react');
var helpers = require('svg-react-loader/helpers')(require('react-dom'));

module.exports = React.createClass({

    displayName: "Warning",

    getDefaultProps () {
        return {"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 64 64"};
    },

    componentDidMount () {
        helpers.applyXmlAttributes(this);
    },

    render () {
        var props = this.props;
        var children = props.children;

        return (
            <svg {...this.props}>
                  <g id="svg-fg">
    <path d="M32,47.5a2.24,2.24,0,1,1,1.59-.66A2.23,2.23,0,0,1,32,47.5Z"/>
    <path d="M32,43.51a1.74,1.74,0,1,1-1.23.51A1.73,1.73,0,0,1,32,43.51m0-1a2.74,2.74,0,1,0,1.94.8,2.73,2.73,0,0,0-1.94-.8Z"/>
    <path d="M32,38A2.2,2.2,0,0,1,29.8,35.8V18.7a2.19,2.19,0,1,1,4.39,0V35.8A2.2,2.2,0,0,1,32,38Z"/>
    <path d="M32,17a1.7,1.7,0,0,1,1.69,1.69V35.8a1.69,1.69,0,0,1-3.39,0V18.69A1.7,1.7,0,0,1,32,17m0-1a2.7,2.7,0,0,0-2.69,2.69V35.8a2.69,2.69,0,0,0,5.39,0V18.69A2.7,2.7,0,0,0,32,16Z"/>
  </g>
                {React.Children.map(children, (c) => (c))}
            </svg>
        );
    }
});



// WEBPACK FOOTER //
// ./src/app/assets/icons/warning.svg